(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('Score', Score);

    Score.$inject = ['$resource', 'DateUtils'];

    function Score ($resource, DateUtils) {
        var resourceUrl =  'api/scores/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
